import { getallUserACTION, insertUpdateUserAction, getUserACTION, userChangeStatusACTION, userDeleteACTION } from "../../actions/UserAdmin/userAdminAction";
import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const INITIAL_STATE = {
    users: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedUser: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    insertUpdateDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    activeInactiveDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    deleteDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

};
const userAdminReducer = createSlice({
    name: "role",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetUserDetailsState(state, action) {
            state.selectedUser = INITIAL_STATE.selectedUser;
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
        },
    },
    extraReducers: (builder) => {

        // getallUserACTION start

        builder.addCase(getallUserACTION.fulfilled, (state, action) => {
            state.users.data = action.payload.data;
            state.users.apiMsg.status = action.meta.requestStatus;
            state.users.apiMsg.message = "success";
        });
        builder.addCase(getallUserACTION.pending, (state, action) => {
            state.users.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getallUserACTION.rejected, (state, action) => {
            state.users.apiMsg.message = action.error.message;
            state.users.apiMsg.status = action.meta.requestStatus;
        });


        // getallUserACTION end
        //------------------------------- getUserACTION start -------------------------

        builder.addCase(getUserACTION.fulfilled, (state, action) => {
            state.selectedUser.data = action.payload.data;
            state.selectedUser.apiMsg.status = action.meta.requestStatus;
            state.selectedUser.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getUserACTION.pending, (state, action) => {
            state.selectedUser.data = null;
            state.selectedUser.apiMsg.message = action.meta.requestStatus;;
            state.selectedUser.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getUserACTION.rejected, (state, action) => {
            state.selectedUser.apiMsg.message = action.error.message;
            state.selectedUser.apiMsg.status = action.meta.requestStatus;
        });


        //   getUserACTION end

        // insertUpdateUserAction start

        builder.addCase(
            insertUpdateUserAction.fulfilled,
            (state, action) => {

                state.insertUpdateDetails.data = action.payload.data.data;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDetails.apiMsg.message = action.payload.message.message;

                if (!action.payload.newRecord) {
                    let updatedRecord = state.users.data.records.map(x => {
                        if (x.id == action.payload.data.data.id) {
                            return action.payload.data.data;
                        }
                        else {
                            return x;
                        }
                    })

                    state.users.data.records = updatedRecord;
                }
                else {
                    if (state.users.data.records.length) {
                        state.users.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        state.users.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );
        builder.addCase(
            insertUpdateUserAction.pending,
            (state, action) => {
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateUserAction.rejected,
            (state, action) => {

                console.log(action.error.message);
                state.insertUpdateDetails.apiMsg.message = action.error.message;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );

        //   insertUpdateUserAction end

        // userChangeStatusACTION start


        builder.addCase(userChangeStatusACTION.fulfilled, (state, action) => {
            state.users.data.records = state.users.data.records.map((item) => {

                return {
                    ...item,
                    active: action.payload.id === item.id ? !item.active : item.active
                }
            })
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
            state.activeInactiveDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(userChangeStatusACTION.pending, (state, action) => {
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(userChangeStatusACTION.rejected, (state, action) => {
            state.activeInactiveDetails.apiMsg.message = action.error.message;
            state.activeInactiveDetails.apiMsg.status = action.meta.requestStatus;
        });


        // userChangeStatusACTION end



        //------------------------------- userDeleteACTION start -------------------------

        builder.addCase(userDeleteACTION.fulfilled, (state, action) => {

            state.users.data.records = state.users.data.records.filter((item, index) => item.id !== action.payload.data.id)

            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
            state.deleteDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(userDeleteACTION.pending, (state, action) => {
            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(userDeleteACTION.rejected, (state, action) => {
            state.deleteDetails.apiMsg.message = action.error.message;
            state.deleteDetails.apiMsg.status = action.meta.requestStatus;
        });
        //------------------------------- userDeleteACTION end -------------------------
    },
});
export const { RESET, ResetUserDetailsState } = userAdminReducer.actions;
export default userAdminReducer.reducer;